import PropTypes from 'prop-types';
// @mui
import { ButtonBase } from '@mui/material';
import { styled } from '@mui/material/styles';
// components
import Iconify from '../../components/Iconify';
// hooks
import useLocales from '../../hooks/useLocales';

// ----------------------------------------------------------------------

// Written for LTR; the app's global stylis-plugin-rtl (see ThemeRtlLayout)
// automatically mirrors this to the left edge when the language is Arabic.
// Do not manually flip left/right here — that would double-mirror.
const StyledTab = styled(ButtonBase)(({ theme }) => ({
  position: 'fixed',
  bottom: 90,
  right: 20,
  zIndex: theme.zIndex.speedDial,
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  padding: theme.spacing(1),
  borderRadius: '50%',
  color: theme.palette.secondary.main,
  '&:hover': {
    backgroundColor: theme.palette.action.hover,
  },
}));

// ----------------------------------------------------------------------

AIInsightsTab.propTypes = {
  onClick: PropTypes.func,
};

export default function AIInsightsTab({ onClick }) {
  const { translate } = useLocales();

  return (
    <StyledTab onClick={onClick} aria-label={translate('aiInsights.title')}>
      <Iconify icon="solar:magic-stick-3-bold-duotone" width={28} height={28} />
    </StyledTab>
  );
}
